import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from "vue";

export type UiButtonColor = 'red' | 'red-white-border' | 'white' | 'grey' | 'grey-blue' | 'blue' | 'soft-blue' | 'soft-blue-outline' | 'soft-gray-outline' | 'red-outline' | 'dark-blue-outline' | 'white-outline';


export default /*#__PURE__*/_defineComponent({
  __name: 'UiButton',
  props: {
	color: {
		type: String as PropType<UiButtonColor>,
		default: "red",
	},
	disabled: Boolean,
	icon: {
		type: String,
		default() {
			return "";
		}
	},
	iconRight: {
		type: String,
		default() {
			return "";
		}
	},
	assetIcon: {
		type: Object,
	},
	inline: {
		type: Boolean,
		default: false
	},
	loading: Boolean,
	size: {
		type: String,
		default: "md"
	},
	href: String,
},
  setup(__props) {

const props = __props



const tagName = computed(() => !!props.href ? 'a' : 'button');

return { __sfc: true,props, tagName }
}

})